import {quantiacs} from './quantiacs';

const quantnetName = 'quantnet';
const quantiacsName = 'quantiacs';

export default class PlatformConfigurator {
    static getNameCurrentVersionPlatform() {
        const {hostname} = window.location;
        if (
            hostname === 'quantiacs.com' ||
            hostname === 'quantiacs.io' ||
            hostname === 'staging-2.quantiacs.io' ||
            hostname === 'localhost'
        ) {
            return quantiacsName;
        }
        if (hostname === 'quantnet.io' || hostname === 'staging.quantnet-ai.ru') {
            return quantnetName;
        }
        return quantiacsName;
    }

    static getConfig() {
        if (PlatformConfigurator.isQuantiacs()) {
            return quantiacs;
        }
        throw new Error('Undefined platform config');
    }

    static isQuantnet() {
        return PlatformConfigurator.getNameCurrentVersionPlatform() === quantnetName;
    }

    static isQuantiacs() {
        return PlatformConfigurator.getNameCurrentVersionPlatform() === quantiacsName;
    }

    static getLogoClass() {
        return PlatformConfigurator.getConfig().general.logoClassName;
    }

    static getContactEmailName() {
        if (PlatformConfigurator.getContactConfig().emailSupport) {
            return PlatformConfigurator.getContactConfig().emailSupport.title;
        }
        return '';
    }

    static getContactConfig() {
        return PlatformConfigurator.getConfig().account.contacts;
    }

    static getRecaptcha() {
        return PlatformConfigurator.getConfig().recaptcha;
    }
}
